import React, { useRef, useEffect } from "react";
import "ol/ol.css";
import Map from "ol/Map";
import View from "ol/View";
import TileLayer from "ol/layer/Tile";
import OSM from "ol/source/OSM";
import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import LineString from "ol/geom/LineString";
import { Style, Stroke, Fill, Text } from "ol/style";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import Polygon from "ol/geom/Polygon";
import { fromLonLat } from "ol/proj";
import Overlay from "ol/Overlay";
import { defaults as defaultControls } from "ol/control";
import PrismaZoom from "react-prismazoom";
declare const window: any;

const MapComponent = ({ data, isSelectedVIA, isMapRender, isSelectedPOI }) => {
  const mapRef = useRef(null);
  const mapInstance: any = useRef(null);

  useEffect(() => {
    if (!mapRef.current || !data || !isSelectedVIA) return;

    const features = [];

    const polygonCoordinates = data?.coordenates_delimitations?.map((coord) =>
      fromLonLat([coord.lng, coord.lat])
    );

    const polygon = new Polygon([polygonCoordinates]);

    const polygonFeature = new Feature({
      geometry: polygon,
    });

    const polygonStyle = new Style({
      stroke: new Stroke({
        color: data?.color_delimitation,
        width: 2,
      }),
      fill: new Fill({
        color: hexToRGBA(data?.color_delimitation, 0.45),
      }),
    });

    polygonFeature.setStyle(polygonStyle);
    features.push(polygonFeature);

    console.log(isSelectedPOI);

    if (isSelectedPOI.length > 0) {
      isSelectedPOI.forEach((pois) => {
        pois?.PoisArray?.forEach((poi) => {
          const poiLat = poi.center.lat;
          const poiLng = poi.center.lng;

          const nuevaLatitud = poiLat * 1.0005;
          const nuevaLongitud = poiLng;

          const lineCoordinates = [
            fromLonLat([poiLng, poiLat]),
            fromLonLat([nuevaLongitud, nuevaLatitud]),
          ];

          const lineGeometry = new LineString(lineCoordinates);

          const lineFeature = new Feature({
            geometry: lineGeometry,
            name: poi.name,
          });

          const lineStyle = new Style({
            stroke: new Stroke({
              color: "#000",
              width: 5,
            }),
          });

          lineFeature.setStyle(lineStyle);
          features.push(lineFeature);

          const textoFeature = new Feature({
            geometry: new Point(fromLonLat([nuevaLongitud, nuevaLatitud])),
            name: poi.name,
          });

          const textoStyle = new Style({
            text: new Text({
              text: poi.name,
              font: "12px Arial",
              fill: new Fill({
                color: "#000",
              }),
              offsetX: 0,
              offsetY: -15,
              textAlign: "center",
              textBaseline: "middle",
              backgroundFill: new Fill({
                color: "rgba(255,255,255,0.8)",
              }),
              backgroundStroke: new Stroke({
                color: "rgba(255,255,255,1)",
                width: 1,
              }),
              padding: [8, 16, 8, 16],
            }),
          });

          textoFeature.setStyle(textoStyle);
          features.push(textoFeature);
        });
      });
    }

    if (isSelectedVIA.length > 0) {
      isSelectedVIA.forEach((via) => {
        const lineCoordinates = via.trace.map((point) =>
          fromLonLat([point.lng, point.lat])
        );
        const lineGeometry = new LineString(lineCoordinates);
        const lineFeature = new Feature({
          geometry: lineGeometry,
          name: via.name,
        });

        const lineStyle = new Style({
          stroke: new Stroke({
            color: via.color,
            width: 10,
          }),
        });

        lineFeature.setStyle(lineStyle);
        features.push(lineFeature);
      });
    }

    const vectorSource = new VectorSource({
      features: features,
    });

    const vectorLayer = new VectorLayer({
      source: vectorSource,
    });

    const map = new Map({
      target: mapRef.current,
      layers: [
        new TileLayer({
          source: new OSM(),
        }),
        vectorLayer,
      ],
      view: new View({
        center: fromLonLat([data.center.lng, data.center.lat]),
        zoom: data.defaultZoom,
      }),
      controls: defaultControls({ zoom: false }), // Aquí desactivas los botones de zoom
    });

    mapInstance.current = map;

    const iconContainer = document.createElement("div");
    iconContainer.style.width = "70px";
    iconContainer.style.height = "70px";
    iconContainer.style.backgroundImage = `url(${
      window.hybrid
        ? "./"
        : "https://d1bsymnertnea6.cloudfront.net/"
    }${data.logo_proyecto.icon})`;
    iconContainer.style.backgroundSize = "contain";
    iconContainer.style.backgroundRepeat = "no-repeat";

    const iconOverlay = new Overlay({
      position: fromLonLat([
        data.logo_proyecto.center.lng,
        data.logo_proyecto.center.lat,
      ]),
      positioning: "center-center",
      element: iconContainer,
      stopEvent: false,
    });

    map.addOverlay(iconOverlay);

    map.getView().on("change:center", () => {
      iconOverlay.setPosition(
        fromLonLat([
          data.logo_proyecto.center.lng,
          data.logo_proyecto.center.lat,
        ])
      );
    });

    map.getView().on("change:resolution", () => {
      iconOverlay.setPosition(
        fromLonLat([
          data.logo_proyecto.center.lng,
          data.logo_proyecto.center.lat,
        ])
      );
    });

    return () => {
      if (map) map.setTarget(undefined);
    };
  }, [data, isSelectedVIA]);

  useEffect(() => {
    if (!mapInstance.current || !isSelectedPOI || isSelectedPOI.length === 0)
      return;

    let newCenter, newZoom, animationDuration;

    if (isSelectedPOI.length > 1) {
      newCenter = fromLonLat([data.center.lng, data.center.lat]);
      newZoom = data.defaultZoom;
      animationDuration = 0; // Sin animación
    } else {
      const poi = isSelectedPOI[0]?.PoisArray[0];
      if (!poi) return;

      newCenter = fromLonLat([
        parseFloat(poi.center.lng),
        parseFloat(poi.center.lat),
      ]);
      newZoom = parseInt(isSelectedPOI[0].zoom, 10);
      animationDuration = 500; // Duración de la animación en milisegundos
    }

    const newView = mapInstance.current.getView();
    newView.animate({
      center: newCenter,
      duration: animationDuration,
    });
    newView.animate({
      zoom: newZoom,
      duration: animationDuration,
    });

    // Evitar el renderizado del mapa durante la animación
    const handleMapRender = () => {
      mapInstance.current.un("postrender", handleMapRender);
      mapInstance.current.getTarget().style.visibility = "visible";
    };
    mapInstance.current.getTarget().style.visibility = "hidden";
    mapInstance.current.on("postrender", handleMapRender);
  }, [isSelectedPOI]);

  useEffect(() => {
    if (!mapInstance.current || !isSelectedVIA || isSelectedVIA.length === 0)
      return;

    let newCenter, newZoom, animationDuration;

    if (isSelectedVIA.length > 1) {
      newCenter = fromLonLat([data.center.lng, data.center.lat]);
      newZoom = data.defaultZoom;
      animationDuration = 0; // Sin animación
    } else {
      const via = isSelectedVIA[0];
      if (!via) return;

      const viaCenter = via.trace.reduce(
        (acc, point) => {
          acc[0] += point.lng;
          acc[1] += point.lat;
          return acc;
        },
        [0, 0]
      );

      newCenter = fromLonLat([
        viaCenter[0] / via.trace.length,
        viaCenter[1] / via.trace.length,
      ]);
      newZoom = parseInt(via.zoom, 10);
      animationDuration = 500; // Duración de la animación en milisegundos
    }

    const newView = mapInstance.current.getView();
    newView.animate({
      center: newCenter,
      duration: animationDuration,
    });
    newView.animate({
      zoom: newZoom,
      duration: animationDuration,
    });

    // Evitar el renderizado del mapa durante la animación
    const handleMapRender = () => {
      mapInstance.current.un("postrender", handleMapRender);
      mapInstance.current.getTarget().style.visibility = "visible";
    };
    mapInstance.current.getTarget().style.visibility = "hidden";
    mapInstance.current.on("postrender", handleMapRender);
  }, [isSelectedVIA]);

  const hexToRGBA = (hex, alpha = 1) => {
    // Elimina el # si está presente
    hex = hex.replace("#", "");

    // Convierte el valor hexadecimal a decimal
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Normaliza los valores de color al rango de 0 a 255
    const alphaNormalized = Math.min(Math.max(alpha, 0), 1);
    const rNormalized = Math.min(Math.max(r, 0), 255);
    const gNormalized = Math.min(Math.max(g, 0), 255);
    const bNormalized = Math.min(Math.max(b, 0), 255);

    // Devuelve el valor RGBA en formato de cadena
    return `rgba(${rNormalized}, ${gNormalized}, ${bNormalized}, ${alphaNormalized})`;
  };

  return isMapRender ? (
    <div className={`mapZoom-container-main`}>
      <div className={`mapZoom-container`}>
        <PrismaZoom
          className="prisma"
          style={{
            width: "300%",
            height: "300%",
            display: "block",
            position: "absolute"
          }}
          initialZoom={0.4}
          maxZoom={2}
          minZoom={0.4}
        >
          <div
            className="map-pan"
            style={{
              backgroundImage: `url(${
                window.hybrid
                  ? ""
                  : "https://d1bsymnertnea6.cloudfront.net/"
              }${data?.mapa_ilustrado_vias.replace(/ /g, "%20")})`,
              backgroundPosition: "50%",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              height: "100%",
              width: "100%",
            }}
          ></div>
        </PrismaZoom>
      </div>
    </div>
  ) : (
    <div
      className="map-container"
      ref={mapRef}
      style={{ position: "relative", height: "100%", width: "100%" }}
    />
  );
};

export default MapComponent;
